import { Button, css, styled, EllipsisText } from 'canoe';
import React from 'react';

const ButtonWrapper = styled.div`
  ${({ theme }) => css`
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    height: ${theme.spaces.s};
  `}
`;

const ButtonWithEllipsis = styled(Button)`
  ${({ theme }) => css`
    height: ${theme.spaces.normal};
    text-align: left;
    overflow: hidden;
  `}
`;

const LinkWithEllipsis = styled.a`
  ${({ theme }) => css`
    color: ${theme.colors.BrandPurple};
    font-size: 14px;
    font-weight: ${theme.fontWeights.bold};
    height: ${theme.spaces.normal};
    line-height: ${theme.spaces.normal};
    text-align: left;
    overflow: hidden;

    &:hover {
      text-decoration: underline;
    }
  `}
`;

interface TableLinkProps {
  text: string;
  link?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  onMouseEnter?: React.MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLDivElement>;
  setReferenceElement?: (instance: HTMLDivElement | null) => void;
}

export const TableLink = React.memo(
  ({ text, link, onClick, onMouseEnter, onMouseLeave, setReferenceElement }: TableLinkProps) => {
    return (
      <ButtonWrapper
        ref={setReferenceElement}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <EllipsisText content={text} placement="bottom">
          {link ? (
            <LinkWithEllipsis href={link}>{text}</LinkWithEllipsis>
          ) : (
            <ButtonWithEllipsis appearance="text" inline onClick={onClick}>
              {text}
            </ButtonWithEllipsis>
          )}
        </EllipsisText>
      </ButtonWrapper>
    );
  },
);
